import React from 'react'
import {MdScreenRotation} from "react-icons/md"

function RotateScreen() {
  return (
    <div className="rotate__wrapper">
      <div className="rotate__icon">
      <MdScreenRotation />
      </div>
      <p className="rotate__copy">Please rotate your screen to landscape or view on desktop.</p>
    </div>
  )
}

export default RotateScreen
